import { ORDER_STATUS } from 'app-shared/lib/api/shared/order.interfaces';
import { RESERVATION_STATUS } from 'app-shared/lib/api/reservation';

export const ORDERS_TO_VALIDATE_OR_PREPARE_STATUSES: ORDER_STATUS[] = ['AWAITING_FULFILLMENT', 'ACCEPTED'];

export const RESERVATIONS_TO_VALIDATE_STATUSES: RESERVATION_STATUS[] = ['REQUESTED'];

export const RESERVATIONS_TO_WELCOME_STATUSES: RESERVATION_STATUS[] = ['CONFIRMED'];
